import type { LenseConfig, SourcesConfig } from '../../../../services/twinService';

/** Resolve a lens's `sources:` vocabulary (spec §2.2) with defaults for absent keys. */
export function sourcesConfigFor(lens?: LenseConfig): SourcesConfig {
  const s = lens?.sources ?? {};
  return {
    noun: s.noun ?? lens?.name ?? '',
    master_role: s.master_role ?? null,
    unassigned_verb: s.unassigned_verb ?? 'assign',
    suggestions: s.suggestions ?? false,
  };
}
